import { Card, Typography } from "@mui/material";
import FichaSolicitacaoAnalise from "./fichaSolicitacaoAnalise";
import ProdutosParaAnalise from "./listaProdutosParaAnalise";
import CreateObservacaoFarmacovigilancia from "./createObservacaoControleQualidade";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import { useState } from "react";
import PreviewAnexos from "../../../utils/PreviewAnexos";

export default function CombineAnalise({ solicitacaoAnalise, setRefresh }) {
    const [previewFiles, setPreviewFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);

    const handleOpenPreview = (documents, fileIndex = 0) => {
        const valid = documents.filter((d) => typeof d === "string" && d.trim() !== "");
        if (!valid.length) return;
        setPreviewFiles(valid);
        setCurrentFileIndex(fileIndex);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => setPreviewOpen(false);

    const handleNavigate = (index) => {
        if (index >= 0 && index < previewFiles.length) {
            setCurrentFileIndex(index);
        }
    };

    return (
        <>
            <FichaSolicitacaoAnalise solicitacaoAnalise={solicitacaoAnalise} />

            <br />
            <Card style={{ padding: 20 }}>
                <HeaderGestorConfigs title={`PRODUCTOS PARA ANÁLISE : ${solicitacaoAnalise?.productos.length}`} />
                <ProdutosParaAnalise itens={solicitacaoAnalise?.productos} solicitacaoId={solicitacaoAnalise?._id} />
            </Card>

            <br />
            <Card>
                <Typography variant="subtitle1" style={{ margin: 20 }}>
                    Documento anexado:
                    {/* <br /> */}
                    <a target="_blank" onClick={(e) => {
                        e.preventDefault();
                        handleOpenPreview([solicitacaoAnalise?.anexo, solicitacaoAnalise?.remetidoPor?.anexoBi], 0);
                    }} >{solicitacaoAnalise?.anexo ? 'Anexo' : ''} </a>
                    <br />
                    <a target="_blank" onClick={(e) => {
                        e.preventDefault();
                        handleOpenPreview([solicitacaoAnalise?.anexo, solicitacaoAnalise?.remetidoPor?.anexoBi], 1);
                    }}  >{solicitacaoAnalise?.remetidoPor?.anexoBi ? 'B.I Remetente' : ''} </a>
                </Typography>
                <iframe
                    id="pdfIframecontroleQualidade"
                    title={`PDF Viewer`}
                    // src={[solicitacaoAnalise?.anexo]}
                    src={[solicitacaoAnalise?.remetidoPor?.anexoBi]}
                    width="100%"
                    height="700px"
                    style={{ border: 'none' }}
                />
            </Card>

            <br />
            <CreateObservacaoFarmacovigilancia
                solicitacaoAnaliseId={solicitacaoAnalise._id}
                // observacoes={expediente?.observacoes}
                setUpdate={setRefresh}
            />
            <PreviewAnexos
                files={previewFiles}
                currentIndex={currentFileIndex}
                isOpen={previewOpen}
                onClose={handleClosePreview}
                onNavigate={handleNavigate}
            />
        </>
    )
}
